<div class="treatment-plans-selector-container">
  <div class="node-info-container">
    <div class="wrapper">
      <div class="node-info-item">
        <div class="item-label">
          <span>Node ID</span>
        </div>
        <div class="item-text label-text">
          <span>{{data.id}}</span>
        </div>
      </div>
      <div class="node-info-item">
        <div class="item-label">
          <span>Treatment Selection Notes</span>
        </div>
        <div>
          <!--input type="text" deep-blur [(ngModel)]="data.note" maxlength="100" size="50"/ -->
          <gen-rich-notes [title]="'Treatment Plan Notes'" (notesChanged)="noteChanged($event)" [notes]="data.note"></gen-rich-notes>
        </div>
      </div>
    </div>
  </div>

  <div class="treatments-top-buttons-container" >
    <div class="treatments-selections">
      <dls-check-box [(ngModel)]="selectAllTreatments" [disabled]="!data.treatmentPlans.length">Select All</dls-check-box>
      <div class="counter-selected">{{selectedCounterText}}</div>
    </div>
    <div class="right-buttons-container">
      <div class="add-btn-container">
        <a href="javascript:void(0)" (click)="addNewTreatmentPlan()">
          <span class="icon__add-new"
                genTooltip [tooltipPosition]="'TOP'" [appendToBody]="true" [tooltipText]="'Add treatment plan'" [tooltipShow]="true"></span>
        </a>
      </div>
      <div class="remove-btn-header-container">
        <a href="javascript:void(0)" (click)="openRemoveTreatmentPlansConfirmationModal()">
          <span class="icon__DeleteTrash" [class.disabled]="!selectedTreatmentsAmount"
                genTooltip [tooltipPosition]="'TOP'" [appendToBody]="true" [tooltipText]="'Delete treatment plans'" [tooltipShow]="true"></span>
        </a>
    </div>
      <div class="collapse-expand-all-btn">
        <a href="javascript:void(0)" (click)="collapseAllTreatmentPlans($event)">
          <span [class]="!allOpen ? EXPAND_ALL_ICON : COLLAPSED_ALL_ICON" [class.disabled]="!selectedTreatmentsAmount"
                genTooltip [tooltipPosition]="'TOP'" [appendToBody]="true" [tooltipText]="'Expand/Collapse all'" [tooltipShow]="true"></span>
        </a>
      </div>
    </div>
  </div>
  <div #treatmentsContainer class="treatments-container">
      <gen-selection-list
        [fields]="[]"
        [counter]="false"
        [listRowType]="'content'"
        [prioritizeAvailable]="true"
        [edit]="true"
        [trackByField]="'treatmentPlanGuid'"
        [listModel]="data.treatmentPlans"
        (listOrderChangedEmit)="orderChanged($event)"
        class="treatments-selection-list">

          <ng-template list-item let-item>
            <p-panel #panel
              [toggleable]="true"
              class="treatment-panel"
              [collapsed]="isCollapsed(item.index)"
              [transitionOptions]="'0ms'"
              [class.collapsed]="isCollapsed(item.index)"
              [class.selected]="isTreatmentSelected(item.index)">

                <p-header class="treatment-header-panel">

                  <div class="Flexbox">
                    <ng-container *ngIf="panel.collapsed && item.data.treatmentPlan">
                      <dls-check-box name="selectTreatment" [value]="item.index" [(ngModel)]="selectedTreatments[item.index]"></dls-check-box>
                      <div class="header-text-container">
                        <div>
                          <a class="header-title" [href]="buildTreatmentPlanUrl(item.data)" target="_blank">
                            <span>{{item.data.treatmentPlan.display}}</span>
                          </a>
                        </div>
                        <div class="Flexbox" *ngIf="panel.collapsed && item.data.treatmentPlanId">
                          <div class="treatment-header-panel-label">
                            <span>ID:</span>
                          </div>
                          <div class="treatment-header-panel-value">
                            <span>{{item.data.treatmentPlanId}}</span>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                  <div class="header-right-buttons-container">
                    <div class="header-icon">
                      <a href="javascript:void(0)" (click)="setPrimary($event, item.index)">
                        <span [class]="isPrimary(item.index) ? PRIMARY_ICON : NON_PRIMARY_ICON"
                              genTooltip [tooltipPosition]="'TOP'" [appendToBody]="true" [tooltipText]="'Mark as primary'" [tooltipShow]="true"></span>
                      </a>
                    </div>
                    <div>
                      <a href="javascript:void(0)" (click)="expandCollapsePanel($event, item.index)">
                        <span [class]="panel.collapsed ? EXPAND_ICON : COLLAPSED_ICON"></span>
                      </a>
                    </div>
                  </div>
                </p-header>
                <div class="treatment-form-container">
                  <dls-check-box name="selectTreatment" [value]="item.index" [(ngModel)]="selectedTreatments[item.index]"></dls-check-box>
                  <gen-dynamic-form
                    class="dynamic-form-table"
                    (formChange)="updateItemValue(item.index,$event.form)"
                    [formData]="item.data"
                    [formName]="payload.config.formName"
                    [editMode]="editMode"
                    [disabled]="disabled"
                    [formVertical]="true"
                    [popupMode]="popupMode"
                    (validateChange)="validationEvent(item.index, $event)"
                    [additionalSearchValues]="revisedEntitiesRevisionsData"
                    [emitFormChangeEvenIfInvalid]="true"
                    (linkClick)="navigateToTreatmentPlanUrl(item.data)">
                  </gen-dynamic-form>
                </div>
            </p-panel>
          </ng-template>

        </gen-selection-list>
    </div>
  <div class="treatments-buttons-container" >
    <div class="right-buttons-container">
      <gen-button [type]="'emphasis'"
                  [iconClass]="'icon__Cross2'"
                  [text]="'Cancel'"
                  (click)="cancel()">
      </gen-button>
      <gen-button [type]="'primary'"
                  [iconClass]="'icon__Checkmark2'"
                  [text]="'Save'"
                  (click)="save()"
                  [disabled]="!isTreatmentPlanSelectorValid() || payload.readOnlyMode">
      </gen-button>
    </div>
  </div>
</div>
